/**
 * Created by Mark on 24/04/2017.
 */

import React  from 'react';

import {NavDropdown , Button , Nav , Navbar, Row, Col} from 'react-bootstrap';
import Panel from './panel.js';
import Translation from '../../store/internationalization-store.js';
import Popup from '../../components/popup/comfirmation_popup.js'
import FieldGroup from '../../components/FieldGroup.js';
import {AccountService} from '../../services';
import AssignmentsService from '../../services/assignments-service'
import Select from  'react-select';
import AssignmentStore from '../../store/assignment-store.js'
import Constants from '../../constants.js';

export default class Profile extends React.Component {

    constructor(props){
        super();
        this.props = props;

        this.state ={
            panelIndex:props.panelIndex||0,
            sidePanel:props.sidePanel,
            allStudents:[]
        };

        this.handelTabSelect = this.handelTabSelect.bind(this);
    }

    handelTabSelect(panel){
        this.setState({panelIndex:panel})
    }

    componentWillReceiveProps(props){
        this.setState({sidePanel:props.sidePanel})
    } 

    componentDidMount(){
        AssignmentsService.getUsersCompleted(this.props.data.homeworkID);
        AssignmentStore.on(Constants.GET_USERS_COMPLETED, ()=>{
            this.state.panelIndex = 0;
            var students = AssignmentStore.lastStudents;
            var allStudents = [];
            var completedStudents = [];
            for (var i =0; i< students.length; i++) {
                allStudents.push({value:students[i].uid, label:students[i].student_name});
                if (students[i].completed == 0) {
                    completedStudents.push({value:students[i].uid, label:students[i].student_name});
                }
            }
            this.setState({
                allStudents:allStudents,
                completedStudents:completedStudents,
                update:true
            })
        })
    }


    render(){
        //this.props.data.homework.id;

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={Translation.get(12788, "Assignment Message")} 
        onSave={()=>{
            AccountService.createMessageStudents(this.state.messageTitle, this.state.messageMessage, this.state.studentData)
            this.setState({addMessage:false});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                <Row><Col><Select placeholder={Translation.get(892, "Select")} isMulti={true} onChange={function(data){
                    this.setState({studentData:data})
                }.bind(this)} name="form-field-name" value={this.state.studentData} />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />
 
        const tabs = this.props.panels.map(function(tab , index){
            if (this.state.allStudents.length < 1 && index < 2) {
                return "";
            }
            return <Nav.Item><Nav.Link key={"panel-"+index} eventKey={index} >{tab.name()}</Nav.Link> </Nav.Item>;
        }.bind(this));
        if (this.state.allStudents.length < 1 && this.state.panelIndex < 2) { 
            this.state.panelIndex = 2;
        }
        const panel     =  this.props.panels[this.state.panelIndex];
        if (panel == undefined) {
            return "";
        }
        const Component = React.createElement(Panel, {
            data:this.props.data,
            component:panel.component
        });


        var edit =  <NavDropdown.Item href={"#/assignments/edit/"+this.props.id}>
            {Translation.get(663 , 'Edit')}
        </NavDropdown.Item>

        

        var messageInComplete = <Button className="justify-content-end" style={{marginRight:"10px"}} onClick={function() {
            this.setState({addMessage:true, messageMessage:"", messageTitle:this.props.data.homework.name, studentData:this.state.completedStudents})
        }.bind(this)}>{Translation.get(12802 , 'Message Incomplete Students')}</Button>

        if (this.state.completedStudents == undefined || this.state.completedStudents.length < 1) {
            messageInComplete = "";
        }

        var messageNormally = <Button className="justify-content-end" style={{marginRight:"10px"}} onClick={function() {
            this.setState({addMessage:true, messageMessage:"", messageTitle:this.props.data.homework.name, studentData:this.state.allStudents})
        }.bind(this)}>{Translation.get(2419 , 'Message All Students')}</Button>

        if (this.state.allStudents.length < 1) {
            edit = "";
            messageNormally = "";
        }



        return  <div body id="profile-main">
            {popup}  
            <Navbar style={{padding:0}}>
                <Nav activeKey={this.state.panelIndex} onSelect={this.handelTabSelect}>
                    {tabs}
                </Nav>
                <Navbar.Collapse className="justify-content-end">
                    {messageInComplete}
                    {messageNormally}
                    <NavDropdown title={Translation.get(12668 , "Options")} id="basic-nav-dropdown">
                        {edit}
                        <NavDropdown.Item href={"#/assignments/duplicate/"+this.props.id}>
                            {Translation.get(2016 , 'Delete')}
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={ ()=>{ this.props.delete() }}>
                            {Translation.get(444 , 'Delete')}
                        </NavDropdown.Item>
                    </NavDropdown>
                </Navbar.Collapse>
            </Navbar>
            <hr/>
                        {Component}
               </div>;

    }

}